// src/pages/Website Home/SmartAppRedirect.js
import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { detectPlatform, buildQueryStringFromParams } from "../../utils/platform";

const IOS_URL_BASE = "https://apps.apple.com/app/6723902761";
const ANDROID_URL_BASE = "https://play.google.com/store/apps/details?id=com.braedentaylor.Toro";

export default function SmartAppRedirect() {
  const navigate = useNavigate();
  const params = useMemo(() => new URLSearchParams(window.location.search), []);

  useEffect(() => {
    const platform = detectPlatform();
    const qs = buildQueryStringFromParams(params);

    if (platform === "ios") {
      window.location.replace(`${IOS_URL_BASE}${qs}`);
      return;
    }

    if (platform === "android") {
      window.location.replace(`${ANDROID_URL_BASE}${qs}`);
      return;
    }

    // desktop or unknown: send them to your organic get-app page
    navigate(`/get-app${qs}`, { replace: true });
  }, [navigate, params]);

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
      <div style={{ textAlign: "center", padding: 24 }}>
        <h1 style={{ margin: 0, fontSize: 22 }}>Redirecting…</h1>
        <p style={{ marginTop: 10, opacity: 0.8 }}>
          Taking you to the correct store.
        </p>
      </div>
    </div>
  );
}
